module.exports = __webpack_public_path__ + "static/media/avtomatizaciyaph.022244a8.jpg";